import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changeIsAccountSettingSpr } from "Store/appStore/action";
import { GetQuery, generateUrlKey, setUrlInSession, setIframeTheme, setIframeZoom, urlAddParams, checkWindowClosable, isInsideTab, isNotDealDark } from "Pub/js/utils";
import Loading from "Components/Loading";
import { getMulti } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
import { getStore } from "Pub/js/storageUtils";
import pubSubActions from "Pub/js/pubSubActions";
const { PubSub } = platform;
import { commontOpenNewWindow } from "Pub/js/superJump";

/**
 * 工作桌面各个应用挂载页面 统一通过 iframe 方式进行加载
 */
class Ifr extends Component {
    constructor(props) {
        super(props);
        this.state = { json: {} };
        this.changeUrl = this.changeUrl.bind(this);
    }

    componentWillMount() {
        let callback = json => {
            // console.log('json', json);
            this.setState({ json: json });
        };
        getMulti({
            moduleId: "ifr",
            // currentLocale: 'zh-CN',
            domainName: "workbench",
            callback,
        });
        //直接用window.open()跳转过来将url放到sessionStorage
        if (URL_IN_SESSION && location.hash.indexOf("ifr=") > 0) {
            this.changeUrl();
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        let ifrOldIfr = this.getIframeNode();
        if (!ifrOldIfr) {return true;}
        const ifr = this.getIfrSrc();
        if (ifr && ifr.includes("#")) {
            if (this.isSameIfr(ifrOldIfr, ifr)) {
                // console.error("ifr含有#没有渲染iframe");
                return false;
            } else {
                // console.error("ifr含有#已经渲染iframe");
                this.unmountReactNode();
                return true;
            }
        } else {
            // console.error("ifr已经渲染iframe");
            return true;
        }
    }

    // ifrNode: iframe节点
    // newSrc: 新的节点地址
    isSameIfr = (ifrNode, newSrc) => {
        // 用正则提取正确的地址对比，之前存在无效对比（../../../../和nccloud/resources/最终请求的资源一样）
        const reg = /(\.\.\/)|(\/?.*\/resources\/)|(\/)|(\\)/g;
        let ifrNew = newSrc.split(".html")[0].replace(reg, '');
        // 通过Attribute获取，直接获取src的内容，反斜杠会变成斜杠
        // 例：mapub/indi/indidata_real_pub\main\index.html会变成mapub/indi/indidata_real_pub/main/index.html
        // let ifrOld = ifrNode.getAttribute('src');
        // 取location.href
        try {
            let ifrOld = ifrNode.contentWindow.location.href.replace(location.origin, '');
            ifrOld = ifrOld.split(".html")[0].replace(reg, '');
            return ifrNew === ifrOld;
        } catch (err) {
            // 输出报错会重定向微应用的地址，访问location存在跨域的可能
            return 'unknown';
        }
    }

    //从其他系统跳转过来将url放到sessionStorage
    changeUrl() {
        const urlKey = generateUrlKey();
        const newUrl = location.hash.substr(location.hash.indexOf("?") + 1);
        setUrlInSession(urlKey, newUrl);
        const targetUrl = `#/ifr?page=${urlKey}`;
        if (isInsideTab()) {
            commontOpenNewWindow(window, targetUrl, urlKey);
        } else {
            location.hash = targetUrl;
        }
    }
    componentDidMount() {
        let ifr = this.getIframeNode();
        const ifrSrc = this.getIfrSrc();
        //内部页签iframe加载时开启loading态
        if (isInsideTab() && ifr && ifrSrc) {
            this.setLoading(true);
            // ifr挂载pageCode
            ifr.contentWindow.pageId = this.props.hash && this.props.hash.split("page=")[1];
        }
        // spr快捷键
        if (ifr) {
            ifr.onload = () => {
                if (isInsideTab()) {
                    //关闭loading态
                    this.setLoading(false);
                }
                if (ifr.contentDocument) {
                    ifr.contentDocument.addEventListener("keydown", event => {
                        //监听iframe内键盘事件
                        PubSub.publish(pubSubActions.global.onIframeKeydown, event);
                    });
                    ifr.contentDocument.addEventListener("click", event => {
                        //监听iframe内click事件
                        PubSub.publish(pubSubActions.global.onIframeClick, event);
                    });

                    const theme = getStore('nccTheme'); // 这里从storage取,打开节点时reducer全局存的会出现获取不到的情况，原因未知（可能时机问题）
                    if (theme) {
                        this.setMicroTheme(theme);
                    }

                    // 设置缩放
                    setIframeZoom(null, ifr.contentDocument);
                    setTimeout(() => { // 领域内部的iframe，这个延迟是为了能确保拿到，也不一定准确，目前没有啥好的方案，除非领域适配
                        const childIframes = ifr.contentDocument.querySelectorAll('iframe');
                        // console.log('领域内部的iframe', childIframes);
                        childIframes.forEach(item => {
                            item.addEventListener('load', () => {
                                setIframeZoom(null, item.contentDocument);
                            });
                        });
                    }, 200);
                }
                // 加载之后聚焦，节点内部快捷键才能响应
                ifr.focus();
            };
        } else {
            //关闭loading态
            if (isInsideTab()) {
                this.setLoading(false);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.theme && (nextProps.theme.type !== this.props.theme.type || nextProps.theme.color !== this.props.theme.color)) { // 主题变化
            // 延迟，确保主题数据已经存储完毕
            setTimeout(() => {
                this.setMicroTheme(nextProps.theme);
            });
        }
        if (this.props.nccFont.fontValue && nextProps.nccFont.fontValue && nextProps.nccFont.fontValue !== this.props.nccFont.fontValue) {
            this.setMicroFont();
        }
        if (this.props.isInsideTab) {
            if (nextProps.visible !== this.props.visible) {
                if (window.__micro__globalEvent) {
                    const { visibilitychange = {} } = window.__micro__globalEvent;
                    for (let k in visibilitychange) {
                        if (k.startsWith(this.props.appKey)) {
                            const visibilityEvents = visibilitychange[k];
                            if (visibilityEvents) {
                                setTimeout(() => { // 延迟执行，避免获取到的元素宽高不正确
                                    visibilityEvents.forEach(c => c({
                                        visibilityState: nextProps.visible ? 'visible' : 'hidden',
                                        isInsideTab: true // platform之前有提供这个给领域，搬过来，报表有用，具体啥用，不知道
                                    }))
                                })
                            }
                        }
                    }
                }
            }
        }
    }

    setMicroFont = () => {
        const iframeNode = this.getIframeNode();
        if (iframeNode && iframeNode.contentWindow && iframeNode.contentWindow.addFontClass) {
            iframeNode.contentWindow.addFontClass();
        }
    }

    setMicroTheme = (theme) => {
        // console.log('set-micro-theme', theme.type);
        const iframeId = this.getIframeNode();
        if (theme.type === 'black') {
            const { hash } = isInsideTab() ? this.props : location;
            const appInfo = GetQuery(hash);
            if (isNotDealDark(appInfo)) {
                iframeId.contentWindow.nccColor = 'default';
                setIframeTheme(iframeId, { themeType: 'default' });
                return;
            }
        }
        setIframeTheme(iframeId, { themeType: theme.type, mixinColor: theme.color });
    }

    // 供组件使用者调用（例：内部页签模式下，检测页签是否可关闭）
    async checkClosable() {
        // __micro__globalEvent 是由platform挂载的
        const { appKey } = this.props;
        const microEvents = window.__micro__globalEvent && window.__micro__globalEvent.beforeunload && window.__micro__globalEvent.beforeunload[appKey];
        if (microEvents) {
            for (let i = 0; i < microEvents.length; i++) {
                const closeResult = await microEvents[i]();
                if (!checkWindowClosable(closeResult)) {
                    return false;
                }
            }
        }
        return true;
    }
    refresh = (beforeCb, afterCb) => {
        this.props.canUnload(() => {
            beforeCb();
            this.unmountReactNode();
            this.props.onAppUnload();
            const ifrNode = this.getIframeNode();
            const newSrc = this.getIfrSrc();
            if (this.isSameIfr(ifrNode, newSrc) === true) {
                ifrNode.contentWindow.location.reload();
            } else {
                // 更改src
                // 节点内部的导出失败可能会重定向节点的location
                ifrNode.src = newSrc;
            }
            setTimeout(() => {
                afterCb();
            })
        })
    }

    getIframeNode = () => this.ncWorkbenchIframeRef.querySelector('iframe')

    unmountReactNode() {
        const ifrNode = this.getIframeNode();
        if (ifrNode) {
            try {
                ifrNode.contentWindow.ReactDOM && ifrNode.contentWindow.ReactDOM.unmountComponentAtNode(ifrNode.contentDocument.querySelector('#app'));
            } catch(e) {
                // debugger
            }
        }
    }

    componentWillUnmount() {
        this.setLoading(false);
        this.unmountReactNode();
        this.props.onAppUnload && this.props.onAppUnload();
    }

    getIfrSrc = () => {
        let { hash } = (isInsideTab() && this.props.isInsideTab) ? this.props : location;
        const urlKey = hash.split('page=').pop();
        const querys = GetQuery(hash);
        let { ifr } = querys;

        if (querys.queryParameters) { // 如果bip跳过来带queryParameters参数 需要拼到ifr
            ifr = urlAddParams(ifr, `queryParameters=${querys.queryParameters}`);
        }

        if (ifr && !ifr.includes('urlKey')) {
            ifr = urlAddParams(ifr, `urlKey=${urlKey}`);
        }
        return ifr;
    }

    setLoading = (loadingStatus) => {
        this.props.onLoadingChange && this.props.onLoadingChange(loadingStatus);
    }

    render() {
        // const themeColor = getStore("nccColor");
        return (
            <div className="nc-workbench-iframe" ref={ref => this.ncWorkbenchIframeRef = ref}>
                {this.props.allowPaint ? (
                    <iframe
                        fieldid={`main_iframe`}
                        id="mainiframe"
                        // 不知道有啥用处，先删掉，否则需要考虑主题切换的情况，这个类要相应改变
                        // className={`${themeColor === "black" ? "nc-lightapp-front-black" : ''}`}
                        style={{ width: "100%", height: "100%" }}
                        frameBorder="0"
                        scrolling="0"
                        src={this.getIfrSrc()}
                    />
                ) : (
                    <Loading />
                )}
            </div>
        );
    }
}

// ---------------乾坤demo---------------
import { loadMicroApp } from "qiankun";
import { initGlobalState } from 'qiankun';
import "./index.less";
const actions = initGlobalState({
    qiankun: '乾坤全局state'
});
const appArr = [
    {
        name: '应用注册',
        entry: `${location.origin}/nccloud/resources/workbenchsetting/pages/developmentconfig/AppRegister/index.html`
    },
    {
        name: '采购订单维护',
        entry: `${location.origin}/nccloud/resources/pu/pu/poorder/main/index.html`
    }
]
class QkIfr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qiankunActive: null,
            iframeActive: null
        };
        this.qiankunInstance = {
            // el: '', // 挂载元素
            // app: '' // app实例
        };
        this.iframeInstance = {};
    }

    componentDidMount() {
        actions.onGlobalStateChange((state, prev) => {
            // state: 变更后的状态; prev 变更前的状态
            console.log('主应用onGlobalStateChange-', state, prev);
        });
    }
    componentWillUnmount() {
        this.qiankunUnmount();
        this.iframeUnmount();
    }
    qiankunLoadApp(app) {
        // 加载微应用
        console.log('加载微应用', app.name);
        const { qiankunActive } = this.state;
        const appKey = Date.now();
        let qiankunNode = document.getElementById('microApp'),
            microAppElement = document.createElement('DIV');
        microAppElement.id = `microApp-${appKey}`;
        microAppElement.style.height = '100%';
        qiankunNode.appendChild(microAppElement);
        qiankunActive && (qiankunActive.el.style.display = 'none'); // 隐藏

        const newQiankun = {
            appKey,
            el: microAppElement,
            app: loadMicroApp({
                name: `microApp-${appKey}`,
                entry: app.entry,
                container: `#microApp-${appKey}`,
                props: {
                    from: `主应用传参至微应用-${app.name}`
                }
            }, {
                sandbox: {
                    // strictStyleIsolation: true, // 这个开启之后子应用的click事件等失效
                    experimentalStyleIsolation: true
                },
                getPublicPath: (path) => {
                    return path; // entry地址
                },
                getTemplate: (tpl) => {
                    return tpl; // html内容
                },
                fetch(url, ...args) {
                    if (url.includes('AppRegister/index.js')) {
                        return new Promise(resolve => {
                            window.fetch(url, ...args).then(res => {
                                res.text().then(txt => { // index.js的文件内容
                                    resolve({
                                        async text() {
                                            return txt;
                                        }
                                    })
                                });
                            })
                        })
                        // return {
                        //     async text() {
                        //         return '';
                        //     },
                        // };
                    }
                
                    return window.fetch(url, ...args);
                },
                excludeAssetFilter: (assetUrl) => { // 指定部分特殊的动态加载的微应用资源（css/js) 不被 qiankun 劫持处理
                    return assetUrl.includes('workbenchsetting/components/Exportcomponents/WorkbenchCard/index');
                }
            })
        }
        this.setState({
            qiankunActive: newQiankun
        })
        this.qiankunInstance[appKey] = newQiankun;
    }
    qiankunUnmount() {
        for (let k in this.qiankunInstance) {
            this.qiankunInstance[k].app.unmount();
            this.qiankunInstance[k].el.remove();
        }
        this.qiankunInstance = {}; // 清空
        this.setState({
            qiankunActive: null
        })
    }
    qiankunUnmountApp(appKey) {
        this.qiankunInstance[appKey].app.unmount();
        this.qiankunInstance[appKey].el.remove();
        delete this.qiankunInstance[appKey];
    }
    iframeLoadApp(app) {
        const appKey = Date.now();
        const { iframeActive } = this.state;
        let iframeNode = document.getElementById('iframeNode');
        let iframeElement = document.createElement('iframe');
        iframeElement.src = app.entry;
        iframeNode.appendChild(iframeElement);
        iframeActive && (iframeActive.el.style.display = 'none');
        const newIframe = {
            appKey,
            el: iframeElement
        }
        this.iframeInstance[appKey] = newIframe;
        this.setState({
            iframeActive: newIframe
        })
    }
    iframeUnmount() {
        for (let k in this.iframeInstance) {
            let el = this.iframeInstance[k].el,
                iframe = el.contentWindow;
                
            //清除文档
            el.src = 'about:blank';
            try {
                iframe.ReactDOM && iframe.ReactDOM.unmountComponentAtNode(iframe.querySelector('#app'));
                iframe.document.write('');
                iframe.document.clear();

                CollectGarbage();
            } catch (e) { };

            //清除节点
            el.remove();
        }
        this.iframeInstance = {};
        this.setState({
            iframeActive: null
        })
    }
    renderTabs = (type) => {
        const { qiankunActive, iframeActive } = this.state;
        const typeMap = {
            'qiankun': {
                instance: this.qiankunInstance,
                active: qiankunActive,
                key: 'qiankunActive',
            },
            'iframe': {
                instance: this.iframeInstance,
                active: iframeActive,
                key: 'iframeActive'
            }
        }
        const instance = typeMap[type].instance;
        const active = typeMap[type].active;
        const activeKey = typeMap[type].key;
        return Object.keys(instance).map(key => 
            <button
                onClick={() => {
                    if (instance[key]) {
                        if (active && active.appKey !== key) {
                            active.el.style.display = 'none';
                            instance[key].el.style.display = '';
                            this.setState({
                                [activeKey]: instance[key]
                            })
                        }
                    }
                }}
                style={{ background: active && active.appKey == key ? '#ccc': '' }}>
                {key}
            </button>
        )
    }
    render() {
        return (
            <div className="nc-workbench-iframe qiankun-demo" ref={ref => this.ncWorkbenchIframeRef = ref} style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <span>qiankun：</span>
                        {
                            appArr.map(item => <button onClick={() => { this.qiankunLoadApp(item) }}>{item.name}</button>)
                        }
                        <button onClick={() => { this.qiankunUnmount() }}>unmount-all</button>
                        <div>
                            {this.renderTabs('qiankun')}
                        </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <span>iframe：</span>
                        {
                            appArr.map(item => <button onClick={() => { this.iframeLoadApp(item) }}>{item.name}</button>)
                        }
                        <button onClick={() => { this.iframeUnmount() }}>unmount-all</button>
                        <div>
                            {this.renderTabs('iframe')}
                        </div>
                    </div>
                </div>
                <div class="style-test">主应用样式隔离测试</div>
                <div style={{display: 'flex'}}>
                    <button onClick={() => {
                        actions.setGlobalState({ qiankun: '主应用来了' });
                    }}>通知子应用</button>
                </div>
                <hr></hr>

                {this.props.allowPaint ? (
                    <div style={{ height: '100%', flex: 1, overflow: 'hidden', display: 'flex' }}>
                        <div id="microApp" style={{ height: '100%', width: '50%' }}>
                        
                        </div>
                        -
                        <div id="iframeNode" style={{ height: '100%', width: '50%' }}>
                            
                        </div>
                    </div>
                ) : (
                    <Loading />
                )}
            </div>
        );
    }
}
Ifr.propTypes = {
    allowPaint: PropTypes.object.isRequired,
    changeIsAccountSettingSpr: PropTypes.func.isRequired,
};
export default connect(
    state => {
        return {
            allowPaint: state.ifrData.allowPaint,
            theme: state.appData.theme,
            nccFont: state.appData.nccFont
        };
    },
    { changeIsAccountSettingSpr },
    null,
    { forwardRef: true },
)(Ifr);
